// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__XhlSU","error":"Textarea_error__Sfp26","readonly":"Textarea_readonly__3GPTD","disabled":"Textarea_disabled__3XDWu"};